import Icon, { IconProps } from './Icon';

import DownloadIcon from '../../../assets/icons/file-download-02.svg?react';

const Download: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <DownloadIcon />
    </Icon>
  );
};

export default Download;
